"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const gatsby_plugin_image_1 = require("gatsby-plugin-image");
const styled_components_1 = __importDefault(require("styled-components"));
var Banner = function Banner(_ref) { var children = _ref.children, altText = _ref.altText; var imgUrl = "../images/banner.png"; return /*#__PURE__*/ React.createElement(BannerGrid, null, /*#__PURE__*/ React.createElement(gatsby_plugin_image_1.StaticImage, { style: { gridArea: "1/1", maxHeight: 400 }, layout: "fullWidth", aspectRatio: 3, alt: altText, src: imgUrl, formats: ["auto", "webp", "avif"], __imageData: require("/home/runner/work/engineering.tracmap.com/engineering.tracmap.com/.cache/caches/gatsby-plugin-image/2430977978.json") }), /*#__PURE__*/ React.createElement(TitleContainer, null, /*#__PURE__*/ React.createElement(BannerTitle, null, children))); };
var BannerGrid = styled_components_1.default.div.withConfig({ displayName: "Banner__BannerGrid", componentId: "sc-3f5x23-0" })(["display:grid;color:#fff;"]);
var TitleContainer = styled_components_1.default.div.withConfig({ displayName: "Banner__TitleContainer", componentId: "sc-3f5x23-1" })(["grid-area:1/1;position:relative;place-items:center;display:grid;text-align:center;"]);
var BannerTitle = styled_components_1.default.h1.withConfig({ displayName: "Banner__BannerTitle", componentId: "sc-3f5x23-2" })(["font-size:40px;font-weight:600;"]);
exports.default = Banner;
